<template>
  <div class="content">
    <navBar :titleTex="title" />

    <div class="box">
      <div class="box-content">
        <img class="discount_des_bg" :src="require('../../assets/'+appTheme+'/discount_des_bg.png')" alt="" />

        <div class="coupon-box">
          <!-- 折扣券 star-->
          <div v-if="discountInfo.type=='discount'" class="discount-box-item">
            <div class="discount-box-default" v-if="discountInfo.is_used==0">
              <img class="discount-item-bg" :src="require('../../assets/'+appTheme+'/discount_des_bg_c2.png')" alt="" />
              <div class="discount-box-content justify-align">
                <div class="discount-item">
                  <div class="discount-num">
                    {{discountInfo.discount | filterDiscount}} <span>折</span>
                  </div>
                  <div class="discount-code">券码：{{discountInfo.code}}</div>
                </div>
                <div class="discount-item discount-item-center">
                  <div class="title left-justifying"><div class="title-txt">{{discountInfo.title}}</div> </div>
                  <div class="goods-txt uni-ellipsis">店铺：{{discountInfo.shop.name}}</div>
                  <!--                <div class="des-goods uni-ellipsis">描述描述，描述描述描述...</div>-->
                  <!--                <div class="hint">最终解释权归该商家</div>-->
                </div>
                <div class="discount-item discount-item-three" @click="clickIsUse">
                  <div class="is_use_box left-justifying">
                    <div class="">
                      <p>立即</p>
                      <p>使用</p>
                    </div>
                    <img :src="require('../../assets/'+appTheme+'/discount_arrow_w.png')" class="use-img" />
                  </div>
                  <div class="date">
                    有效期至
                  </div>
                  <span>{{discountInfo.use_endtime}}</span>
                </div>
              </div>
            </div>
            <!--        已使用-->
            <div class="discount-is-used-box discount-box-default" v-else>
              <img class="discount-item-bg" :src="require('../../assets/'+appTheme+'/discount_bg2.png')" alt="" />
              <div class="discount-box-content justify-align">
                <div class="discount-item">
                  <div class="discount-num">
                    {{discountInfo.discount | filterDiscount}} <span>折</span>
                  </div>
                  <div class="discount-code">券码：{{discountInfo.code}}</div>
                </div>
                <div class="discount-item discount-item-center">
                  <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{discountInfo.title}}</div> </div>
                  <div class="goods-txt">店铺：{{discountInfo.shop.name}}</div>
                  <!--                <div class="des-goods uni-ellipsis">描述描述，描述描述描述...</div>-->
                  <!--                <div class="hint">最终解释权归该商家</div>-->
                </div>
                <div class="discount-item discount-item-three">
                  <img class="is_use_txt" :src="require('../../assets/'+appTheme+'/is_use_txt.png')" alt="" />
                  <div class="date">
                    有效期至
                  </div>
                  <span>{{discountInfo.use_endtime}}</span>
                </div>
              </div>
            </div>
          </div>
          <!--  折扣券end-->
          <!--  代金券star-->
          <div v-if="discountInfo.type=='subsidy'" class="voucher-item-box">
            <!--  未使用-->
            <div class="voucher-default-box" v-if="discountInfo.is_used==0">
              <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/voucher_bg.png')" alt="" />
              <div class="voucher-item-content left-justifying">
                <div class="price-box">
                  <div style="margin-top: 6.66667vw;">￥<span>{{discountInfo.amount}}</span></div>
                  <div class="voucher-number">券码：{{discountInfo.code}}</div>
                </div>
                <div class="center-voucher-box">
                  <div class="center-voucher-title left-justifying">
                    <div class="title-txt uni-ellipsis">{{discountInfo.title}}</div>
                    <img :src="require('../../assets/'+appTheme+'/voucher_arrow.png')" alt="" />
                  </div>
                  <div class="voucher-shop uni-ellipsis" v-if="discountInfo.shop != null">店铺：{{discountInfo.shop.name}}</div>
                  <div class="voucher-shop-des uni-ellipsis">{{discountInfo.desc}}</div>
                  <div class="voucher-shop-coy">最终解释权归该商家</div>
                </div>
              </div>
              <div class="voucher-is-use-box" >
                <div class="voucher-btn-top content-center" @click="clickIsUseSubsidy">
                  <div class="voucher-btn-txt">
                    <div>使用</div>
                    <div>立即</div>
                  </div>
                  <img class="discount_arrow_w" :src="require('../../assets/'+appTheme+'/discount_arrow_w.png')" alt="" />
                </div>
                <div class="voucher-btn-bottom">
                  <span>有效期至</span>
                  <span style="display: block;font-size: 2.4vw;">{{discountInfo.use_endtime}}</span>
                </div>
              </div>
            </div>
            <!--  未使用end-->
            <!--  已使用star-->
            <div class="voucher-default-box voucher-default-box2" v-else>
              <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/voucher_bg2.png')" alt="" />
              <div class="voucher-item-content left-justifying">
                <div class="price-box">
                  <div style="margin-top: 6.66667vw;">￥<span>{{discountInfo.amount}}</span></div>
                  <div class="voucher-number">券码：{{discountInfo.code}}</div>
                </div>
                <div class="center-voucher-box">
                  <div class="center-voucher-title left-justifying">
                    <div class="title-txt uni-ellipsis">{{discountInfo.title}}</div>
                    <img :src="require('../../assets/'+appTheme+'/q_xiala2.png')" alt="" />
                  </div>
                  <div class="voucher-shop uni-ellipsis">店铺：{{discountInfo.shop.name}}</div>
                  <div class="voucher-shop-des uni-ellipsis">{{discountInfo.desc}}</div>
                  <div class="voucher-shop-coy">最终解释权归该商家</div>
                </div>
              </div>
              <div class="voucher-is-use-box">
                <img :src="require('../../assets/'+appTheme+'/is_use_txt.png')" alt="" class="voucher-btn-top-img">
                <div class="voucher-btn-bottom">
                  <span>有效期至</span>
                  <span style="display: block">{{discountInfo.use_endtime}}</span>
                </div>
              </div>
            </div>
            <!--  已使用end-->

          </div>
          <!--  代金券end-->
          <!--        优先券 star-->
          <div v-if="discountInfo.type=='ticket'" class="coupon-item-box">
            <div class="is-use-box-default" v-if="discountInfo.is_used==0">
              <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/q_bg.png')" alt="" />
              <div class="coupon-item-content">
                <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{discountInfo.title}}</div><img :src="require('../../assets/'+appTheme+'/q_xiala.png')" class="q_xiala" /> </div>
                <div class="goods-txt uni-ellipsis">{{discountInfo.desc}}</div>
                <div class="date">有效期至{{discountInfo.use_endtime}}</div>
                <div class="hint">最终解释权归该商家</div>
              </div>
              <div class="use-box" @click="clickIsUseTicket">
                <div class="use-txt">去使用</div>
                <img :src="require('../../assets/'+appTheme+'/q_arrow.png')" class="use-img" />
                <div class="use-number">券码：{{discountInfo.code}}</div>
              </div>
            </div>
            <!--        已使用-->
            <div class="is-use-box-default is-use-box-default2" v-else>
              <img class="coupon-item-bg" :src="require('../../assets/'+appTheme+'/q_bg2.png')" alt="" />
              <div class="coupon-item-content">
                <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{discountInfo.title}}</div><img :src="require('../../assets/'+appTheme+'/q_xiala2.png')" class="q_xiala" /> </div>
                <div class="goods-txt uni-ellipsis">{{discountInfo.desc}}</div>
                <div class="date">有效期至{{discountInfo.use_endtime}}</div>
                <div class="hint">最终解释权归该商家</div>
              </div>
              <div class="use-box">
                <img :src="require('../../assets/'+appTheme+'/is_use_txt.png')" class="use-img" />
                <div class="use-number">券码：{{discountInfo.code}}</div>
              </div>
            </div>
          </div>
          <!--  优先券end-->
          <div class="instructions-box">
            <p class="instructions-title">用券说明：</p>
            <div class="instructions-content">
              <div class="instructions-item left-justifying" style="align-items: flex-start">
                <span></span>
                <p>{{discountInfo.desc}}</p>
              </div>
              <div v-if="discountInfo.type=='ticket'" class="instructions-item left-justifying" style="align-items: flex-start">
                <span></span>
                <p>可优先购买 <b style="color: #f32d2d;">{{discountInfo.one_pay_goods.title}}</b>商品</p>
              </div>
              <div class="instructions-item left-justifying" style="align-items: flex-start" v-if="discountInfo.type=='subsidy'&& discountInfo.sufficient_amount !='0.00'">
                <span></span>
                <div style="color: #666;" class="" v-if="discountInfo.sufficient_amount !='0.00'"><span>满</span> {{discountInfo.sufficient_amount}} <span>可用</span></div>
              </div>
              <!--              <div class="instructions-item left-justifying" style="align-items: flex-start">-->
              <!--                <span></span>-->
              <!--                <p>说明内容说明内容说明内容说明内容说明内容说内容说明-->
              <!--                  内容说明内容说明内容说明内容说明内容说明内容说明内-->
              <!--                  容说明内容说明内容说明内容说明内容说明内容。</p>-->
              <!--              </div>-->
              <div class="instructions-item left-justifying" style="align-items: flex-start">
                <span></span>
                <p>最终解释权归商家</p>
              </div>
            </div>

          </div>
        </div>
        <!--  折扣券end-->
      </div>

    </div>

  </div>
</template>

<script>
import navBar from "@/components/navBar";
export default {
name: "couponDes",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      title:'优惠券详情',
      discountInfo: '',
      comType: 0,
      couponInfo: {
        is_used: 0
      }
    }
  },
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  // beforeCreate() {		//在页面创建之前设置body的背景色
  //   document.querySelector('body').setAttribute('style', 'background: #FDD80D;')
  // },
  // beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
  //   document.querySelector('body').removeAttribute('style')
  // },
  components: {
    // coupon,
    navBar
  },
  created() {

    var item = JSON.parse(this.$route.query.item)
    console.log(item)
    this.discountInfo = item
    this.comType = this.$route.query.comType
  },
  methods: {
    clickIsUse(){
      this.$router.push({path:'/shopDes',query: {id:this.discountInfo.shop.id}})
    },
    clickIsUseSubsidy(){
      if(this.discountInfo.shop==null){
        this.$router.push({path:'/goodClassify'})
      } else {
        this.$router.push({path:'/shopDes',query: {id:this.discountInfo.shop.id}})
      }
    },
    clickIsUseTicket(){
      let useful_stock = this.discountInfo.one_pay_goods.useful_stock // 是否秒杀有库存
      let goods_id = this.discountInfo.one_pay_goods.goods_id
      let pro_id = this.discountInfo.one_pay_goods.id
      this.$router.push({path:'/goodDetails',query:{id:goods_id,type:pro_id,isPay:useful_stock}})
    }
  }
}
</script>

<style lang="scss" scoped>
.van-hairline--bottom::after {
  border-bottom-width: 0;
}
.box{
  position: fixed;width: 100%;height: 100%;background: #FDD80D;
}
.box-content{
  padding-top: 25px;position: relative;width: 726px;margin: 0 auto;
  .discount_des_bg{
    display: block;width: 726px;height: auto;
  }
  .coupon-box{
    position: absolute;
    left: 0;top: 45px;z-index: 3;width: 100%;
  }
}

  .discount-box-item{
    width: 666px;margin: 25px auto 0;
    .discount-box-default{
      position: relative;box-shadow: 0 0 30px #b4b4b4;margin: 0 auto;

    }
    .discount-item-bg{
      width: 666px;height: auto;display: block;
    }
    .discount-box-content{
      position: absolute;z-index: 2;
      left: 20px;
      top: 30px;
      .discount-num{
        font-weight: bold;font-size: 50px;margin-bottom: 30px;
        color: #FF953A;
        span{

          font-size: 26px;
        }
      }
      .discount-code{
        font-size: 14px;
        font-weight: 400;
        color: #FF953A;
      }
      .title{
        .title-txt{
          font-size: 28px;
          font-weight: bold;color: #282828;padding-right: 10px;
        }
        img{
          width: 12px;display: inline-block;height: auto;margin-left: 20px;
        }
      }
      .discount-item-center{
        padding: 0 10px;font-size: 22px;width: 270px;margin-left:50px;text-align: left;color: #9E9E9E;
        .goods-txt{
          display: inline-block;
          background: #FFF0E5;
          border-radius: 22px;font-weight: 400;
          color: #FB6666;font-size: 22px;padding: 10px 10px;margin:10px auto;width: 90%;
        }
        .des-goods{
          width: 100%;margin-bottom: 10px;
        }
      }
      .discount-item-three{
        padding: 0 10px;font-size: 20px;font-weight: 400;text-align: left;margin-left: 20px;
        color: #FFFFFF;
        .date{
          margin-top: 12px;margin-bottom: 5px;
        }
      }
      .is_use_box{
        font-size: 34px;color: #FFFFFF;

      }
      .use-img{
        width: 48px;display: block;height: auto;margin-left: 15px;
      }
    }
    .discount-is-used-box{
      .discount-box-content{
        .discount-item{
          .discount-num{

            color: #8C8787;
          }
          .discount-code{
            color: #8C8787;
          }
          .title-txt{
            color: #8C8787;
          }
          .goods-txt{
            background: #E6E6E6;color: #8C8787;
          }
          .date{
            margin-top: 10px;
          }
          .is_use_txt{
            width: 122px;display: block;height: auto;margin-top: -5px;
          }
        }
        .discount-item-three{
          span{
            display: block;
          }
        }
      }
    }
  }
  .instructions-box{
    padding: 20px 20px 20px 40px;margin-top: 60px;
    font-size: 24px;
    .instructions-title{
      margin-top: 20px;margin-bottom: 20px;text-align: left;
    }
    .instructions-content{
      .instructions-item{
        margin-bottom: 30px;text-align: left;
        span{
          display: block;
          width: 9px;
          height: 9px;
          background: #282828;
          border-radius: 50%;margin-right: 20px;margin-top: 10px;
        }
        p{
          width: 90%;line-height: 40px;
        }
      }

    }

  }
  //代金券
.voucher-item-box{
  margin:28px 20px 0;position: relative;
  .voucher-default-box{
    .coupon-item-bg{
      width: 100%;display: block;height: auto;
    }
    .voucher-item-content{
      position: absolute;width:500px;height: auto;left: 20px;top: 30px;
      .price-box{
        font-size: 28px;
        font-weight: bold;padding-right: 5px;
        color: #F34B09;width: 180px;text-align: center;height: 180px;
        span{
          font-size: 45px;
        }
        .voucher-number{
          font-weight: 400;
          color: #FF953A;font-size: 18px;position: absolute;bottom: 10px;left: 15px;
        }
      }
      .center-voucher-box{
        width: 310px;
        .center-voucher-title{
          width: 100%;
          .title-txt{
            overflow: hidden;
            font-size: 28px;
            font-weight: bold;
            color: #E9400B;width: 70%;
          }
          img{
            width: 12px;display: inline-block;height: auto;
          }
        }
        .voucher-shop{
          width: 234px;
          overflow: hidden;color: #FB6666;font-size: 22px;
          background: #FFF0E5;text-align: center;
          border-radius: 19px;margin: 10px 0;padding: 5px 5px;text-align: left;
        }
        .voucher-shop-des{
          font-size: 22px;font-weight: 400;margin: 10px 0;
          color: #9E9E9E;width: 80%;overflow: hidden;
        }
        .voucher-shop-coy{
          font-size: 20px;font-weight: 400;
          color: #9E9E9E;
        }
      }
    }
    .voucher-is-use-box{
      position: absolute;width: 190px;height: auto;right: 0;top: 0;text-align: center;
      .voucher-btn-txt{
        font-size: 36px;font-weight: 400;margin-top: 20px;
        color: #FFFFFF;
      }
      .discount_arrow_w{
        width: 48px;height: auto;display: inline-block;margin-left: 10px;
      }
      .voucher-btn-bottom{
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;margin-top: 20px;
        line-height: 40px;
      }
    }
  }
  .voucher-default-box2{
    .voucher-item-content{
      .price-box{

        color: #8C8787;
        .voucher-number{
          color: #8C8787;
        }
      }
      .center-voucher-box{

        .center-voucher-title{

          .title-txt{

            color: #8C8787;width: 70%;
          }

        }
        .voucher-shop{
          color: #8C8787;
          background: #E6E6E6;
        }
        .voucher-shop-des{

          color: #9E9E9E;
        }
        .voucher-shop-coy{
          font-size: 20px;font-weight: 400;
          color: #9E9E9E;
        }
      }
    }

    .voucher-is-use-box{
      .voucher-btn-top-img{
        width: 132px;display: block;margin:20px auto 5px;height: auto;
      }
      .voucher-btn-bottom{
        margin-top: 0;line-height: 35px;
      }
    }

  }
}
//优先券
.is-use-box-default{
  position: relative;
}
.coupon-item-box{
 margin: 28px 20px 0;
  position: relative;
  .coupon-item-bg{
    width: 100%;height: auto;display: block;margin: 0 auto;
  }
  .coupon-item-content{
    position: absolute;z-index: 2;width: 460px;left: 60px;top: 40px;text-align: left;
    .title{
      margin-bottom: 14px;
    }
    .title-txt{
      font-weight: bold;
      color: #E9740B;font-size: 32px; max-width: 80%;
    }
    .q_xiala{
      width: 12px;height: auto;display: inline-block;margin-left: 20px;
    }
    .goods-txt{
      background: #FFF0E5;
      border-radius: 19px;font-size: 22px;font-weight: 400;
      color: #E9740B;display: inline-block;padding: 2px 10px;
      max-width: 80%;
    }
    .date{
      color: #E9740B;font-size: 20px;margin-bottom: 8px;
    }
    .hint{
      font-size: 20px;
      font-weight: 400;
      color: #9E9E9E;
    }
  }
  .is-use-box-default2{
    .title-txt{
      color: #8C8787;
    }
    .goods-txt{
      color: #8C8787;background: #E6E6E6;
    }
    .date{
      color: #8C8787;
    }
    .use-img{
      width: 132px;height: auto;
      display: block;margin: 0 auto 10px;
    }
  }
  .use-box{
    position: absolute;z-index: 2;right: 0;top: 40px;width: 190px;text-align: center;
    .use-txt{
      font-size: 36px;color: #FFFFFF;
    }
    .use-number{
      font-size: 18px;color: #FFFFFF;
    }
    img{
      width: 48px;height: auto;display: block;margin: 15px auto 25px;
    }
  }
}
</style>
